import { IWixAPI } from '@wix/native-components-infra/dist/src/types/types';

import { ISearchLocation } from './location.types';
import { decodePath, encodePath } from './path';

const SEARCH_RESULTS_PAGE_ID = 'search_results';

export const toLocationSearchRequest: ISearchLocation['toLocationSearchRequest'] = ({
  paging,
  ...searchRequest
}) => {
  return {
    ...searchRequest,
    page: paging.page,
  };
};

export const buildSearchResultsUrl: ISearchLocation['buildSearchResultsUrl'] = (
  searchResultsAbsoluteUrl,
  locationSearchRequest,
) => {
  return `${searchResultsAbsoluteUrl}/${encodePath(locationSearchRequest)}`;
};

export const createSearchLocation = (wixCodeApi: IWixAPI): ISearchLocation => {
  function getSectionUrl() {
    return wixCodeApi.site.getSectionUrl({
      sectionId: SEARCH_RESULTS_PAGE_ID,
    });
  }

  return {
    decodePath,
    encodePath,

    getSearchResultsRelativeUrl: async () => {
      const { relativeUrl } = await getSectionUrl();
      return relativeUrl;
    },

    getSearchResultsAbsoluteUrl: async () => {
      const { url } = await getSectionUrl();
      return url;
    },

    navigateToSearchResults: async searchRequest => {
      const { relativeUrl } = await getSectionUrl();
      wixCodeApi.location.to(`${relativeUrl}/${encodePath(searchRequest)}`);
    },

    toLocationSearchRequest,

    toSDKSearchRequest: ({ page, ...searchRequest }, pageSize: number) => {
      return {
        ...searchRequest,
        paging: {
          page,
          pageSize,
        },
      };
    },

    buildSearchResultsUrl,
  };
};
